import axios from "@/plugins/axios";
import { getApiUrl } from "@/services/_apiUrl";

const apiUrl = getApiUrl();

export function fetchApiKeys(params = {}) {
  return axios.get(apiUrl.apiKeys.GET.LIST, { params });
}

export function createApiKey(data) {
  return axios.post(apiUrl.apiKeys.POST, data);
}

export function deleteApiKey(apiKeyId) {
  return axios.delete(`${apiUrl.apiKeys.DELETE}${encodeURIComponent(apiKeyId)}/`);
}
